module.exports = __webpack_public_path__ + "media/images/japan/map-cdc930461c82df18626d0b4f2cf497ab.png";